module.exports = __webpack_public_path__ + "src/assets/img/trank_open_light_stop.261a59ec.svg";